module.exports = __webpack_public_path__ + "img/activeSet1.aec77b17.png";